module.exports = __webpack_public_path__ + "img/CH.bfd8bbbd.png";